module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment comment__container"
  }, [_c('a', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.message.user.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'comment__self': _vm.selfMessage(_vm.message.user)
    }
  }, [_c('a', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.message.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "metadata"
  }, [_c('span', {
    staticClass: "date comment__date"
  }, [_vm._v(" " + _vm._s(_vm._f("fromNow")(_vm.message.timestamp)))])]), _vm._v(" "), (!_vm.isFile(_vm.message)) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.message.content))]) : _c('img', {
    staticClass: "ui image comment__image",
    attrs: {
      "src": _vm.message.image,
      "alt": "image"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f730114"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/SingleMessage.vue
// module id = 219
// module chunks = 1